import React from "react";
import Privacy from "../components/Privacy";

function PrivacyContainer() {
  return <Privacy></Privacy>;
}

export default PrivacyContainer;
